<template>
    <AnagraficaCrud titolo="Comuni (zone climatiche)" endpoint="comuni" nuovo-label="Nuovo comune" :colonne="colonne"
        :campi="campi" :filtri="filtri" :puo-scrivere="true" :limite="500"
        colonne-import="CodComune, Comune, Cap, Provincia (sigla), Stato, Regione, Zona, grg (gradi giorno)" />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

const LOOKUP_PROVINCE = { endpoint: "province", title: "sigla", value: "sigla" };

export default {
    name: "ComuniPage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Comune", key: "nome" },
                { title: "Prov.", key: "provincia" },
                { title: "Cap", key: "cap" },
                { title: "Zona", key: "zona" },
                { title: "Gradi giorno", key: "grg" },
                { title: "Cod. comune", key: "codComune" },
            ],
            campi: [
                { key: "nome", label: "Comune", tipo: "text", required: true },
                { key: "provincia", label: "Provincia", tipo: "lookup", lookup: LOOKUP_PROVINCE, required: true },
                { key: "cap", label: "Cap", tipo: "text" },
                { key: "codComune", label: "Codice comune", tipo: "text" },
                { key: "zona", label: "Zona climatica (A-F)", tipo: "text" },
                { key: "grg", label: "Gradi giorno", tipo: "number", step: 1 },
                { key: "regione", label: "Regione", tipo: "text" },
                { key: "stato", label: "Stato", tipo: "text" },
            ],
            filtri: [{ key: "provincia", label: "Provincia", lookup: LOOKUP_PROVINCE, titleKey: "sigla", valueKey: "sigla" }],
        };
    },
};
</script>
